/** Traced from `src/assets/symbols/fåtölj 3-01.svg` (MANUAL/Lounge-chair-1). */
export const LOUNGE_CHAIR_1_SVG_BOUNDS = {
  minX: 14.585,
  maxX: 87.238,
  minY: 21.782,
  maxY: 94.377,
} as const;

export const LOUNGE_CHAIR_1_SHELL_SVG_OUTLINE: [number, number][] = [
  [81.1173, 92.9321],
  [82.3822, 91.317],
  [84.3409, 87.0242],
  [85.5038, 82.3488],
  [86.5035, 76.8022],
  [87.238, 68.6629],
  [86.7688, 56.422],
  [85.3202, 45.8388],
  [83.0351, 38.4858],
  [78.8526, 31.4303],
  [73.3032, 26.6062],
  [68.3658, 24.1835],
  [65.0402, 22.9722],
  [53.1252, 21.7821],
  [44.1073, 21.7821],
  [34.6202, 23.5672],
  [26.1532, 28.1788],
  [20.3589, 34.4268],
  [18.2574, 39.1871],
  [15.7479, 47.5814],
  [14.789, 54.7644],
  [14.585, 75.9946],
  [15.6867, 84.219],
  [16.5028, 86.2379],
  [19.1959, 90.5306],
  [21.8687, 92.8046],
  [24.1129, 93.7609],
  [25.3167, 93.9096],
  [26.3572, 93.9096],
  [27.2957, 93.5909],
  [28.173, 92.8471],
  [28.5199, 92.337],
  [28.9279, 89.9781],
  [28.3158, 89.5319],
  [27.9486, 89.0855],
  [27.2549, 86.7691],
  [26.5, 83.0926],
  [26.0308, 77.121],
  [26.5408, 68.0466],
  [27.6017, 59.5035],
  [29.0095, 55.0194],
  [32.0495, 50.5354],
  [35.0282, 47.6452],
  [37.7622, 45.86],
  [42.4547, 44.8825],
  [48.9631, 44.2874],
  [53.6964, 44.2874],
  [62.5715, 45.7325],
  [66.5704, 48.0064],
  [70.3244, 51.7467],
  [72.9359, 56.6345],
  [74.5069, 62.9037],
  [75.1394, 69.0242],
  [75.3638, 76.6109],
  [74.5681, 83.9852],
  [73.3236, 88.9581],
  [72.4667, 89.8506],
  [72.3442, 91.8695],
  [72.8135, 93.3358],
  [73.7928, 94.1434],
  [76.69, 94.3772],
  [79.4035, 94.0371],
  [81.1173, 92.9321],
];

export const LOUNGE_CHAIR_1_CUSHION_SVG_OUTLINE: [number, number][] = [
  [72.748, 89.8506],
  [73.609, 88.9581],
  [74.8596, 83.9852],
  [75.6592, 76.6109],
  [75.4337, 69.0242],
  [74.7981, 62.9037],
  [73.2195, 56.6345],
  [70.5953, 51.7467],
  [66.823, 48.0064],
  [62.8047, 45.7325],
  [53.8865, 44.2874],
  [49.1302, 44.2874],
  [42.5902, 44.8825],
  [37.8748, 45.86],
  [35.1276, 47.6452],
  [32.1344, 50.5354],
  [29.0796, 55.0194],
  [27.665, 59.5035],
  [26.5989, 68.0466],
  [26.0864, 77.121],
  [26.5579, 83.0926],
  [27.3165, 86.7691],
  [28.0135, 89.0855],
  [28.3826, 89.5319],
  [28.9976, 89.9781],
  [29.4486, 90.1906],
  [30.2072, 90.4669],
  [32.0523, 90.9132],
  [33.467, 91.1044],
  [34.041, 91.1682],
  [45.7884, 91.317],
  [58.5404, 91.487],
  [64.2398, 91.572],
  [67.069, 91.5082],
  [70.0623, 91.0194],
  [71.0464, 90.7007],
  [71.6614, 90.4669],
  [71.9689, 90.3181],
  [72.3585, 90.1056],
  [72.625, 89.9356],
  [72.748, 89.8506],
];
